import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { HeaderLoginService } from '../../services/header-login.service';
import { AccessService } from '../../services/access.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  form: any = {
    email: null,
    pass: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];


  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private headerLoginService: HeaderLoginService,
    private accesS: AccessService
  ) { }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().role;
      this.idMBU = this.tokenStorage.getUser().id;
    }
  }

  /* Metodo para conseguir el primer enlace del usuario que esta logeando para direccionarlo*/
  idMBU = '';
  firstUrlLogged = '';
  getFirstModulByUser() {
    this.accesS.getFirstNameModulForPerson(this.idMBU).subscribe({
      next: res => {
        this.firstUrlLogged = (res['data'])[0].modulo;
        this.router.navigate(['/adm/' + this.firstUrlLogged])
      },
      error: err => {
        console.log(err['message']);
      }
    })
  }

  onSubmit(): void {
    const { email, pass } = this.form;
    this.authService.login(email, pass).subscribe({
      next: data => {
        this.tokenStorage.saveToken(data.token);
        this.tokenStorage.saveUser(data.user);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().role;
        this.idMBU = this.tokenStorage.getUser().id;
        this.getFirstModulByUser();
        //controlamos la info de la cabecera de login
        this.headerLoginService.shooterLogin.emit({
          data: true,
        });

      },
      error: err => {
        this.errorMessage = err['error'].msn;
        this.isLoginFailed = true;
      }
    });
  }

}
